import { render, staticRenderFns } from "./FlashMessage.vue?vue&type=template&id=af9aa870&scoped=true&"
import script from "./FlashMessage.vue?vue&type=script&lang=js&"
export * from "./FlashMessage.vue?vue&type=script&lang=js&"
import style0 from "./FlashMessage.vue?vue&type=style&index=0&id=af9aa870&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9aa870",
  null
  
)

export default component.exports